import React from 'react';

import './DiscountProgramBenefits.scss';
import icons from '../../shared/assets/icons';
import sendEvent from '../../helpers/tracking';
import { getString } from '../../helpers/styles';
import { setItem } from '../../helpers/localStorage';

const { CheckBox } = icons;

export default function DiscountProgramBenefits(props) {
  return (
    <section className="discountProgramBenefits">
      <h2>Voordelen</h2>
      <h3>
        Afhankelijk van jouw behoefte lopen de besparingen als snel op naar
        minimaal €500,-
      </h3>

      <ul className="discountProgramBenefits_list">
        <Item
          text="Kortingen en gratis producten van merken zoals HEMA,
          Meyco en Plein"
        />

        <Item
          text="Meer dan 120 speciaal voor jou geselecteerde voordelen
          van hoge kwaliteit welke nergens anders voordeliger zijn"
        />

        <Item isBold={true} text="Nu tijdelijk €12,95 i.p.v. €14,95" />
      </ul>

      <button
        onClick={() => {
          if (props.eventTrackingCodes) sendEvent(...props.eventTrackingCodes);

          handleClick(props);
        }}
        className="discountProgramBenefits_button"
      >
        Lid worden
      </button>
    </section>
  );
}

function Item(props) {
  return (
    <li className="discountProgramBenefits_list_item">
      <div>
        <CheckBox />
      </div>

      <div
        className={getString(
          'discountProgramBenefits_list_item_bold',
          props.isBold
        )}
      >
        {props.text}
      </div>
    </li>
  );
}

function handleClick(props) {
  if (props.link) return (location.href = props.link);

  if (!props.user.username) {
    setItem('originalUrl', '/discount-program-register');

    return props.showLoginPopup(`Wat fijn dat je lid wilt worden van
      het Familie Voordeel Programma. Log in met je account om je
      lidmaatschap aan te vragen`);
  }

  location.href = '/discount-program-register';
}
